import { cn } from "../../../lib/utils";
import { Marquee } from "../../../shadcomponents/ui/marquee";

interface DynamicMarqueeProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => JSX.Element;
  duration?: string; // e.g. "20s"
  pauseOnHover?: boolean;
  reverse?: boolean;
  vertical?: boolean;
}

export function DynamicMarquee<T>({
  items,
  renderItem,
  duration = "20s",
  pauseOnHover = true,
  reverse = false,
  vertical = false,
}: DynamicMarqueeProps<T>) {
  return (
    <Marquee
      pauseOnHover={pauseOnHover}
      reverse={reverse}
      vertical={vertical}
      className={cn(`[--duration:${duration}]`)}
    >
      {items.map((item, index) => renderItem(item, index))}
    </Marquee>
  );
}
